<template>
  <div class="edit-box">
    <ModulesNavigationBox :nb-modules="minorModules"
                          :nb-type="'edit'"
                          :nb-navigation-name="'settings'"
                          :nb-minor-name="'edit'"
                          :nb-minor-active="activeMinorModule"></ModulesNavigationBox>
    <router-view name="editContent"
                 :active-module="activeModule"
                 :user="user"
                 :gameId="gameId"
                 :discover-server-location="discoverServerLocation"
                 :active-edit-mode="activeMinorModule"></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModulesNavigationBox from '../components/ModulesNavigationBox';

export default {
  name: 'EditBox',
  components: { ModulesNavigationBox },
  data() {
    return {
      editContent: null,
    };
  },
  computed: {
    ...mapGetters([
      'activeModule',
      'discoverServerLocation',
      'user',
      'editActive',
      'gameId',
      'minorModules',
      'activeMinorModule',
    ]),
    getProperParam() {
      let prop = 'id';
      switch (this.activeModule.id) {
        case 'outcomes':
          prop += '_outcome';
          break;
        case 'markets':
          prop += '_bet';
          break;
          // no default
      }
      return prop;
    },
  },
  methods: {
    ...mapActions([
      'setEdit',
      'fetchEditModules',
      'setActiveMinorModule',
      'setEditModeData',
      'setNotificationMessage',
    ]),
  },
  mounted() {
    this.setEditModeData();
    this.$store.commit('SET_ACTIVE_MINOR_MODULES', 'translations');
    this.fetchEditModules();
    this.$router.push('/settings/edit/translations');
  },
  beforeDestroy() {
    this.setEdit(false);
    this.setActiveMinorModule();
    this.setNotificationMessage();
  },
};
</script>

<style lang="scss" scoped>
  .edit-box {
    background-color: #fff;
    bottom: 0;
    left: 0;
    padding: 10px;
    position: absolute;
    right: 0;
    top: 50px;
    z-index: 4;
    .edit-box-navigations {
      background-color: transparent;
      box-shadow: inset 0 -1px 0 0 #d3dadd;
      font-size: 14px;
      height: 50px;
      margin-bottom: 10px;
      .edit-navigation {
        color: #808b9c;;
        height: 100%;
        padding: 0 20px;
        position: relative;
        &.active {
          color: #009aff;
          &:before {
            width: 100%;
            left: 0;
            background-color: #009aff;
          }
        }
        &:before {
          background-color: transparent;
          bottom: 0;
          content: "";
          height: 3px;
          left: 30%;
          position: absolute;
          transition: all .5s;
          width: 40%;
        }
      }
      &.minor {
        background-color: transparent;
        box-shadow: inset 0 -1px 0 0 #d3dadd;
        margin-bottom: 10px;
        .module {

          &.active {
            color: #009aff;
          }
          &:before {
            bottom: 0;
            top: auto;
          }
        }
      }
    }
  }
</style>
